import { ILanguage } from 'my-poppies-b2b-types';

const languageToLocale: Record<ILanguage, { locale: string; currency: string }> = {
  en: { locale: 'en-US', currency: 'EUR' },
  de: { locale: 'de-DE', currency: 'EUR' },
};

export const usePrice = (language: ILanguage) => {
  return (amount: number) => {
    const { locale, currency } = languageToLocale[language] || languageToLocale.en;
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };
};
